import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../../components/Layout';
import Content from '../../../components/Pages/Users/View';

const { displayName } = config;

export default function UserEdit(): React.ReactNode | null {
  document.title = `${displayName}: User view`;

  return (
    <Layout
      title="User view"
    >
      <Content />
    </Layout>
  );
}
